import * as React from "react";
import { List as VirtualList } from "react-window";
import styled from "styled-components";
import ElementDimensions from "components/common/ElementDimensions";
import isFilteredField from "views/logic/IsFilteredField";
import ListItem from "./ListItem";
const DEFAULT_HEIGHT_PX = 50;
const DynamicHeight = styled(ElementDimensions)`
  overflow: hidden;
`;
const _fieldsToShow = (fields, allFields, currentGroup = "all") => {
  const isNotReservedField = (f) => !isFilteredField(f.name);
  switch (currentGroup) {
    case "all":
      return allFields.filter(isNotReservedField).toList();
    case "allreserved":
      return allFields;
    case "current":
    default:
      return fields.filter(isNotReservedField).toList();
  }
};
const RowComponent = ({ index, style, fieldList, activeQueryFields }) => /* @__PURE__ */ React.createElement(ListItem, { fieldType: fieldList.get(index), activeQueryFields, style });
const List = ({ filter, activeQueryFields, allFields, currentGroup }) => {
  if (!activeQueryFields) {
    return /* @__PURE__ */ React.createElement("span", null, "No field information available.");
  }
  const fieldFilter = filter ? (field) => field.name.toLocaleUpperCase().includes(filter.toLocaleUpperCase()) : () => true;
  const fieldsToShow = _fieldsToShow(activeQueryFields, allFields, currentGroup);
  const fieldList = fieldsToShow.filter(fieldFilter).sortBy((field) => field.name.toLocaleUpperCase()).toList();
  if (fieldList.isEmpty()) {
    return /* @__PURE__ */ React.createElement("i", null, "No fields to show. Try changing your filter term or select a different field set above.");
  }
  return /* @__PURE__ */ React.createElement(DynamicHeight, null, ({ width, height }) => /* @__PURE__ */ React.createElement(
    VirtualList,
    {
      style: { height: height || DEFAULT_HEIGHT_PX, width },
      rowComponent: RowComponent,
      rowCount: fieldList.size,
      rowHeight: 20,
      rowProps: {
        fieldList,
        activeQueryFields
      }
    }
  ));
};
export default List;
